import { render } from "./ProfileMarkNavigation.vue?vue&type=template&id=b94bf4f4&scoped=true"
import script from "./ProfileMarkNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileMarkNavigation.vue?vue&type=script&lang=js"

import "./ProfileMarkNavigation.vue?vue&type=style&index=0&id=b94bf4f4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94bf4f4"]])

export default __exports__